import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewInit
} from '@angular/core';
import { SideBar } from '../sidebar/siderbar';
import { LanguageService } from '../../../service/language.service';

@Component({
  selector: 'app-appli-side-bar',
  templateUrl: './appli-side-bar.component.html',
  styleUrls: ['./appli-side-bar.component.scss']
})
export class AppliSideBarComponent implements OnInit, AfterViewInit {
  @Input() sidebars: SideBar<string, string>[];
  @Input() focusIndex: number;
  @Output() clickEventIndex = new EventEmitter<number>();
  @Output() focusEventIndex = new EventEmitter<number>();
  @Output() allFocusReset = new EventEmitter();
  @Output() setFocus = new EventEmitter<number>();
  lang = '';
  constructor(private languageService: LanguageService) {}
  ngOnInit() {
    this.lang = this.languageService.language;
  }

  ngAfterViewInit(): void {
    const menu_list = document.querySelector('.active') as HTMLElement;
    menu_list.focus();
  }

  click(index: number) {
    this.clickEventIndex.emit(index);
    this.focusEventIndex.emit(index);
  }
  focus(i: number) {
    //this.sidebars.forEach(d => (d.focused = false));
    //this.sidebars[i].focused = true;
    this.focusEventIndex.emit(i);
  }
  blur() {
    this.allFocusReset.emit();
  }
}
